<!--  -->
<template>
  <div>

    <span style="color: red">*本页面的绑定关系需要主体在企微后台真实授权小程序才能生效*</span>
    <el-tabs v-model="activeName" style="margin-top: 15px" type="card" @tab-click="handleClick">
      <el-tab-pane label="自由人小程序" name="first">
        <chhosewechat ref="chhosewecahtr" @callback="callback" />
      </el-tab-pane>
      <el-tab-pane label="外部小程序" name="second">
        <bandwai ref="bandwaiview" @callwechatrcr="callwechatrcr" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import chhosewechat from '../../squaredappletSconfigure/components/chhosewechat.vue'
import bandwai from './bandwai.vue'
export default {
  components: { chhosewechat, bandwai },
  data() {
    return {
      activeName: 'first'
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    handleClick(val) {
      console.log(this.activeName)
      if (this.activeName === 'first') {
        this.$nextTick(() => {
          this.$refs.chhosewecahtr.send()
        })
      } else {
        this.$nextTick(() => {
          this.$refs.bandwaiview.send()
        })
      }
    },
    callback(item) {
      this.$emit('callitem', item)
      console.log('item', item)
    },
    send() {
      this.$nextTick(() => {
        this.$refs.chhosewecahtr.send()
      })
    },
    callwechat(item) {
      this.$emit('callwechatr', item)
      console.log(item)
    },
    callwechatrcr(item) {
      this.$emit('callwechatrcr', item)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
